<template>
  <v-app id="inspire">
    <v-card class="overflow-hidden" elevation="0">
      <app-bar></app-bar>
      <v-sheet id="scrolling_sheet" class="overflow-y-auto" :max-height="windowHeight - 1">
        <v-main>
          <v-container fluid class="mt-15">
            <router-view></router-view>
          </v-container>
          <app-footer></app-footer>
        </v-main>
      </v-sheet>
    </v-card>
    <message-dialog v-if="$store.state.messageDialog.isShowing"></message-dialog>
    <v-snackbar
      :color="$store.getters.getOptions.color"
      v-model="$store.state.snackbar.isShowing"
      :multi-line="false"
    >{{$store.getters.getOptions.text}}</v-snackbar>
  </v-app>
</template>

<script>
import AppFooter from "@/components/AppFooter";
import AppBar from "@/components/AppBar";
import MessageDialog from "@/components/MessageDialog";

export default {
  components: {
    appBar: AppBar,
    appFooter: AppFooter,
    messageDialog: MessageDialog,
  },
  props: {
    source: String,
  },
  data: () => ({
    windowHeight: window.innerHeight,
    scrolling: document.getElementById("scrolling"),
    dialog: false,
  }),
  watch: {
    // windowHeight(newHeight, oldHeight) {
    //   console.log(`it changed to ${newHeight} from ${oldHeight}`);
    // },
  },
  computed: {},
  created() {
    this.updateCurrentLocale();
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },

  methods: {
    updateCurrentLocale() {
      let userLang = navigator.language || navigator.userLanguage;
      let supportedLocales = ["ru", "en", "es"];
      if (Array.isArray(userLang.split("-"))) {
        let newLocale = userLang.split("-")[0];
        if (
          this.$vuetify.lang.current != newLocale &&
          supportedLocales.includes(newLocale)
        ) {
          this.$vuetify.lang.current = newLocale;
        }
      }
    },
    onResize() {
      this.windowHeight = window.innerHeight;
    },
  },
};
</script>

<style>
.rcorners {
  border-radius: 15px;
  background: #ccc;
}
</style>